// extracted by mini-css-extract-plugin
module.exports = {"container":"empty_container__zM2k6","img":"empty_img__2Z38U"};